"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safePath = void 0;
const monet_1 = require("monet");
const path_1 = __importDefault(require("ramda/src/path"));
const { None, fromNull } = monet_1.Maybe;
function safePath(safePath, x) {
    return arguments.length === 2
        ? fromNull((0, path_1.default)(safePath, x || {}))
        : (y) => fromNull((0, path_1.default)(safePath, y || {}));
}
exports.safePath = safePath;
//# sourceMappingURL=safePath.js.map